const PERSON_ROUTES = {
  ROOT: "/person",
  AFFILIATION: `/person/roster/affiliation`,
  R_DATA: `/person/roster/registration-data`,
  R_ROLES: `/person/roster/roles`,
  ATTR: `/person/roster/attributes`,
  C_INFO: `/person/roster/address-contacts`,
  LMS: `/person/roster/LMS-training`,
  INSIGHT: `person/roster/insights`,
  ROSTER_ROLES: `/person/roster/roles`,
  BROWSER: `/person/browser`,
  ROLES: `/person/roles`,
  FINDER: `/person/find`,
  ADMIN: `/administration`,
  IDP: `/IDP`
};
const INSTITUTION_ROUTES = {
  ROOT: "/institution",
  AFFILIATION: "/institution/roster/affiliation",
  ADDRESSES_CONTACTS: "/institution/roster/address-contacts",
  SITE_RESTRICTIONS: "/institution/roster/site-restrictions",
  COPY_PERSONS: "/institution/roster/copy-persons",
  ATTRIBUTES: "/institution/roster/attributes",
  CREDENTIALS: "/institution/roster/credentials",
  PROVIDERS: "/institution/roster/providers",
  NMC_BROWSER: "/institution/nmc-browser",
  FIND: "/institution/roster/find",
  BROWSER: "/institution/browser",
  FWA_BROWSER: "/institution/fwa-browser"
};
const ADMIN_ROUTES = {
  ROOT: "/admin",
  RUMS: "admin/rums-setup",
  MAPPINGS: "admin/approval-mappings",
  PERSON_ROLE_SETUP: "admin/person-role-setup",
  ATTRIBUTE_SETUP: "admin/attribute-setup",
  MANAGE_COMMITTEES: "admin/manage-committees",
  NCI_LAPS_GRANT: "admin/laps-grant-administration",
  UNREGISTERED_INSTITUTIONS: "admin/unregistered-institutions"
};
export { ADMIN_ROUTES, INSTITUTION_ROUTES, PERSON_ROUTES };
